import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const AccountsTable = lazy(() =>
  import(/* webpackChunkName: "AccountsTable" */ '../../components/rewards/AccountsTable')
);

export default function AsyncAccountsTable({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <AccountsTable {...props} />
    </Suspense>
  );
}
